import { useCallback, useEffect, useRef } from "react";

import { skippableWait } from "./skippableWait";

/**
 * React hook that provides a skippable wait function with automatic cleanup.
 *
 * @returns Object with wait function and manual skip function
 */
export function useSkippableWait() {
  const activeWaitRef = useRef<(() => void) | undefined>(undefined);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      activeWaitRef.current?.();
    };
  }, []);

  const wait = useCallback(async (ms: number): Promise<void> => {
    // Skip any existing wait
    activeWaitRef.current?.();

    // Start new wait
    const { wait: promise, skipWait } = skippableWait(ms);
    activeWaitRef.current = skipWait;

    await promise;
    activeWaitRef.current = undefined;
  }, []);

  const skip = useCallback(() => {
    activeWaitRef.current?.();
    activeWaitRef.current = undefined;
  }, []);

  return { wait, skip };
}
